import { BaseService, Service } from "/@/cool";
@Service("agentSharingDetails")
class AgentSharingDetails extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["page"] = prefix + "page";
	}

	agentSharingDetails(data: any) {
		return this.request({
			url: "/page",
			method: "POST",
			data
		});
	}
}
export default AgentSharingDetails;
